export default __webpack_public_path__ + "static/media/newslit-wordmark-logo.46caa533.png";